module.exports = __webpack_public_path__ + "static/media/practice-shade22.72585313.png";